import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const sendInvitationFriend = (senderName, friendName, emailFriend) => {
    const url = `${URL_BASE_API}/api/invitation/sendInvitationFriend`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: senderName,
        field02: friendName,
        field03: emailFriend,
        lang: language
    });
    
    return rsp;
}